import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, where, getCountFromServer } from 'firebase/firestore';
import { useAuth } from '../contexts/AuthContext';
import { Shield, GitBranch, BookOpen } from 'lucide-react';

export default function HeroSection() {
  const { initializing } = useAuth();
  const [totalReports, setTotalReports] = useState(0);
  const [verifiedReports, setVerifiedReports] = useState(0);
  const [categoriesTracked, setCategoriesTracked] = useState(0);

  useEffect(() => {
    if (initializing) return;

    const fetchCounts = async () => {
      try {
        const [totalSnap, verifiedSnap, matrixSnap] = await Promise.all([
          getCountFromServer(collection(db, 'posts')),
          getCountFromServer(query(collection(db, 'posts'), where('verified', '==', true))),
          getCountFromServer(collection(db, 'fraudMatrix')),
        ]);
        setTotalReports(totalSnap.data().count);
        setVerifiedReports(verifiedSnap.data().count);
        setCategoriesTracked(matrixSnap.data().count);
      } catch (e) {}
    };

    fetchCounts();
  }, [initializing]);

  return (
    <div className="glass-card rounded-2xl p-8 mb-8 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-cyan-500/20 to-purple-500/20 rounded-full blur-3xl"></div>
      <div className="relative z-10">
        <h1 className="text-4xl md:text-5xl font-black mb-4 bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent">
          Report Crypto Fraud. Protect the Community.
        </h1>
        <p className="text-lg text-gray-300 mb-6">
          CFE is an open-source intelligence platform where the crypto community reports, verifies, and exposes scams — making DeFi safer for everyone.
        </p>
        <div className="flex flex-wrap gap-3 mb-6">
          <Link
            to="/submit"
            className="flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-black font-bold py-2.5 px-5 rounded-lg text-sm transition-all hover:opacity-90"
          >
            <Shield size={16} />
            Report a Scam
          </Link>
          <Link
            to="/matrix"
            className="flex items-center gap-2 border border-cyan-500/50 text-cyan-400 hover:bg-cyan-500/10 font-semibold py-2.5 px-5 rounded-lg text-sm transition-all"
          >
            <GitBranch size={16} />
            Fraud Matrix
          </Link>
          <Link
            to="/learn"
            className="flex items-center gap-2 border border-cyan-500/50 text-cyan-400 hover:bg-cyan-500/10 font-semibold py-2.5 px-5 rounded-lg text-sm transition-all"
          >
            <BookOpen size={16} />
            Learn to Spot Scams
          </Link>
        </div>
        <div className="flex flex-wrap gap-4">
          <div className="glass-card px-4 py-2 rounded-lg">
            <span className="text-2xl font-bold text-cyan-400">{totalReports.toLocaleString()}</span>
            <span className="text-sm text-gray-400 ml-2">Reports Filed</span>
          </div>
          <div className="glass-card px-4 py-2 rounded-lg">
            <span className="text-2xl font-bold text-green-400">{verifiedReports.toLocaleString()}</span>
            <span className="text-sm text-gray-400 ml-2">Verified Reports</span>
          </div>
          <div className="glass-card px-4 py-2 rounded-lg">
            <span className="text-2xl font-bold text-purple-400">{categoriesTracked.toLocaleString()}</span>
            <span className="text-sm text-gray-400 ml-2">Scam Categories Tracked</span>
          </div>
        </div>
      </div>
    </div>
  );
}